// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".playlist .playlist_header{background:linear-gradient(180deg,#232323 0,#0b0b0b);border-top-left-radius:6px;padding:15px;text-align:center}.playlist .playbutton{color:#fff;display:block;font-size:1.5em;left:50%;opacity:1;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:12}@media(min-width:1200px){.playlist .playlist_header{margin-left:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
